const Xs = '500px'
const Sm = '740px'
const Md = '900px'
const Lg = '1080px'
const Xl = '1200px'
const Xxl = '1540px'

export const Theme = {
  breakpoints: [Xs, Sm, Md, Lg, Xl, Xxl],
  colors: {
    red: '#bf0000',
    darkRed: '#9a0200',
    steelBlue: '#2e5369',
    ironBlue: '#224458',
    midnightBlue: '#172831',
    brightBlue: '#0a679a',
    aqua: '#5fc1c8',
    orange: '#fe9b28',
    pebbleGray: '#e6e6d7',
    lightGray: '#dedede',
    black: '#000000',
    white: '#ffffff'
  },
  space: [0, 4, 8, 12, 16, 24, 32, 48, 64, 128, 256],
  fonts: {
    condensed: 'Roboto Condensed, sans-serif'
    //wide: 'DrukWide, sans-serif',
    //body: 'Campton Book, sans-serif'
  },
  fontSizes: ['1rem', '1.25rem', '1.875rem'],
  bodyFontSizes: ['1rem', '1.125rem', '1.25rem'],
  responsiveFontSizes: ['0.875rem', '1rem', '1.25rem']
}

export const breakpoints = {
  xs: Xs,
  sm: Sm,
  md: Md,
  lg: Lg,
  xl: Xl,
  xxl: Xxl
}

export const MediaQueries = Object.keys(breakpoints).reduce((acc, breakKey) => {
  return {
    ...acc,
    [breakKey]: `@media (min-width: ${breakpoints[breakKey]})`
  }
}, {})
// note: needs a separate property for border color
